import {Layout} from "./Layout.js";

export class CompanyProfileLayout extends Layout {

    template() {
        const {sectionId = ''} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            <div id="companyNameLayer"></div>
                            <div id="companyCategorySelectLayer" class="select-wrap"> </div>
                            <div id="hopeCountSelectLayer" class="select-wrap"></div>
                            ${this.getNexPageButtonTemplate()}
                            ${this.getNextLinkTemplate()}
                        </div>
                    </article>
                </section>`
    }
    getNexPageButtonTemplate() {
        const {nextButton = {}} = this.$props;
        return  Object.values(nextButton).length > 0  ?  `<button id = "${nextButton.id}" class="join-comp-button js-next-page-button" >${Mutil.n2v(nextButton.text)}</button>` : "";
    }
}